module.exports = __webpack_public_path__ + "img/img-bg.41a6a394.jpg";